import { render, staticRenderFns } from "./ExportStatsCampaignsModal.vue?vue&type=template&id=48d04c46&scoped=true"
import script from "./ExportStatsCampaignsModal.vue?vue&type=script&lang=ts"
export * from "./ExportStatsCampaignsModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48d04c46",
  null
  
)

export default component.exports